<template>
	<div class="ui-dialog-footer">
		<slot/>
	</div>
</template>

<script>
export default {
	name: "DialogFooter"
};
</script>

<style lang="scss" scoped>
.ui-dialog-footer {
	position: relative;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	.ui-button {
		margin: 0;
		+ .ui-button {
			margin-left: 8px;
		}
	}
}
</style>
